document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(max-width: 749px)');

  const targetLink = document.querySelector('a[href="/pages/faq"]');
  const backgroundImage = document.querySelector('.homepage-top__section-background__image');
  if (!targetLink || !backgroundImage) return;

  let observer = null;

  let tracking = false;
  let startScrollY = 0;

  let rafId = null;
  let currentY = 0;
  let targetY = 0;
  const SMOOTHING = 0.18;

  const setTransform = (y) => {
    backgroundImage.style.transform = `translate3d(0, ${y}px, 0)`;
  };

  const updateLoop = () => {
    if (!tracking) return;

    const delta = window.scrollY - startScrollY;
    targetY = Math.min(0, -delta);

    currentY += (targetY - currentY) * SMOOTHING;
    if (Math.abs(targetY - currentY) < 0.1) currentY = targetY;

    setTransform(currentY);
    rafId = requestAnimationFrame(updateLoop);
  };

  const startTracking = () => {
    if (tracking) return;

    tracking = true;
    startScrollY = window.scrollY;

    currentY = 0;
    targetY = 0;

    backgroundImage.style.willChange = 'transform';
    setTransform(0);

    // ✅ match body bg while this behavior is active
    document.body.classList.add('bg-match');

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(updateLoop);
  };

  const stopTrackingAndReset = () => {
    tracking = false;

    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;

    currentY = 0;
    targetY = 0;
    setTransform(0);

    // ✅ revert body bg
    document.body.classList.remove('bg-match');
  };

  const setupObserver = () => {
    if (observer) return;

    observer = new IntersectionObserver(
      ([entry]) => {
        const viewportTrigger = window.innerHeight * 0.75;
        const linkBottom = entry.boundingClientRect.bottom;

        const shouldTrack = linkBottom <= viewportTrigger - 2;

        if (shouldTrack) startTracking();
        else stopTrackingAndReset();
      },
      {
        threshold: 0,
        rootMargin: '-75% 0px 0px 0px',
      }
    );

    observer.observe(targetLink);
  };

  const destroyObserver = () => {
    stopTrackingAndReset();
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };

  const handleMediaChange = (e) => {
    if (e.matches) setupObserver();
    else destroyObserver();
  };

  handleMediaChange(mq);
  mq.addEventListener('change', handleMediaChange);
});


// document.addEventListener('DOMContentLoaded', () => {
//   const mq = window.matchMedia('(max-width: 749px)');

//   const targetLink = document.querySelector('a[href="/pages/faq"]');
//   const backgroundImage = document.querySelector('.homepage-top__section-background__image');

//   // ---------- Feature: Smoothly move background image up with scroll after trigger ----------
//   let observer = null;

//   let tracking = false;
//   let startScrollY = 0;

//   // RAF smoothing
//   let rafId = null;
//   let currentY = 0;   // what we’re currently applying
//   let targetY = 0;    // what we want based on scroll
//   const SMOOTHING = 0.18; // 0.12–0.25 range; higher = snappier

//   const setTransform = (y) => {
//     backgroundImage.style.transform = `translate3d(0, ${y}px, 0)`;
//   };

//   const updateLoop = () => {
//     if (!tracking) return;

//     const delta = window.scrollY - startScrollY;
//     // const maxTranslate = 40; // match inset bleed on bg image

//     targetY = Math.min(0, -delta);
//     // targetY = Math.max(-maxTranslate, targetY);

//     currentY += (targetY - currentY) * SMOOTHING;

//     if (Math.abs(targetY - currentY) < 0.1) currentY = targetY;

//     setTransform(currentY);
//     rafId = requestAnimationFrame(updateLoop);
//   };

//   const startTracking = () => {
//     if (tracking) return;
//     if (!backgroundImage) return;

//     tracking = true;
//     startScrollY = window.scrollY;

//     currentY = 0;
//     targetY = 0;

//     backgroundImage.style.willChange = 'transform';
//     setTransform(0);

//     if (rafId) cancelAnimationFrame(rafId);
//     rafId = requestAnimationFrame(updateLoop);
//   };

//   const stopTrackingAndReset = () => {
//     tracking = false;

//     if (rafId) cancelAnimationFrame(rafId);
//     rafId = null;

//     if (backgroundImage) {
//       currentY = 0;
//       targetY = 0;
//       setTransform(0);
//       // Optional: remove will-change if you prefer
//       // backgroundImage.style.willChange = '';
//     }
//   };

//   const setupObserver = () => {
//     if (!targetLink || !backgroundImage || observer) return;

//     observer = new IntersectionObserver(
//       ([entry]) => {
//         const viewportTrigger = window.innerHeight * 0.75;
//         const linkBottom = entry.boundingClientRect.bottom;

//         // tiny hysteresis so it doesn’t flap near the boundary
//         const shouldTrack = linkBottom <= viewportTrigger - 2;

//         if (shouldTrack) startTracking();
//         else stopTrackingAndReset();
//       },
//       {
//         threshold: 0,
//         rootMargin: '-75% 0px 0px 0px',
//       }
//     );

//     observer.observe(targetLink);
//   };

//   const destroyObserver = () => {
//     stopTrackingAndReset();
//     if (observer) {
//       observer.disconnect();
//       observer = null;
//     }
//   };

//   // ---------- Breakpoint handler ----------
//   const enableMobileBehavior = () => {
//     if (mq.matches) setupObserver();
//   };

//   const disableMobileBehavior = () => {
//     destroyObserver();
//   };

//   const handleMediaChange = (e) => {
//     if (e.matches) enableMobileBehavior();
//     else disableMobileBehavior();
//   };

//   // Initial
//   handleMediaChange(mq);

//   // Listen for breakpoint changes
//   mq.addEventListener('change', handleMediaChange);
// });




